import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";

@Injectable()
export class EmailService {
  constructor(private _http: HttpClient) {}

  sendReservationFormData(formData) {
    return this._http
      .post("/api/reservation/send", { formData: formData })
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  sendContactFormData(formData) {
    return this._http
      .post("/api/contact/send", { formData: formData })
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  // sendMuralsFormData(formData) {
  //   return this._http
  //     .post("http://localhost:8080/api/artworks/send", { formData: formData }, { headers : { 'Content-Type': 'application/json' } } )
  //     // .post("http://localhost:8080/api/artworks/send", { formData: formData } )
  //     .map((response: Response) => response)
  //     .toPromise()
  //     .catch(this.handleError);
  // }

  private handleError(error) {
    console.error(error);
    if (error.status == 404) {
      // alert('Please change all references to /confidential/fixture/work.json to /fixture/work.json in the work.service.ts file');
    }
    return Observable.throw(error.json().error || "Server error");
  }
}



// WEBPACK FOOTER //
// ./src/app/services/email/email.service.ts